/**
 * <klapi-zoom> : diaporama de la carte "Zoom sur" du hero.
 * Diapos [data-diapo], barres de progression [data-barre].
 * Défilement automatique (data-intervalle en ms), en pause au survol et au focus,
 * désactivé si l'utilisateur préfère réduire les animations.
 */
// Le script peut être inclus par plusieurs sections : l'élément n'est déclaré qu'une fois
if (!customElements.get('klapi-zoom')) {
  class KlapiZoom extends HTMLElement {
    connectedCallback() {
      this.diapos = [...this.querySelectorAll('[data-diapo]')];
      this.barres = [...this.querySelectorAll('[data-barre]')];
      if (this.diapos.length < 2) return;

      this.index = 0;
      this.intervalle = Number(this.dataset.intervalle) || 5000;
      this.style.setProperty('--k-intervalle', `${this.intervalle}ms`);

      this.barres.forEach((barre, i) => barre.addEventListener('click', () => this.aller(i, true)));

      const pause = () => this.toggleAttribute('data-pause', true);
      const reprise = () => this.removeAttribute('data-pause');
      this.addEventListener('pointerenter', pause);
      this.addEventListener('pointerleave', reprise);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', reprise);

      // La fin de l'animation de la barre active déclenche la diapo suivante.
      this.addEventListener('animationend', (event) => {
        if (event.animationName === 'k-barre') this.aller((this.index + 1) % this.diapos.length);
      });

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.toggleAttribute('data-lecture', true);
      }
    }

    aller(i, manuel = false) {
      this.index = i;
      this.diapos.forEach((diapo, j) => {
        diapo.hidden = j !== i;
      });
      this.barres.forEach((barre, j) => {
        if (j === i) barre.setAttribute('aria-current', 'true');
        else barre.removeAttribute('aria-current');
      });
      // Relance l'animation de la nouvelle barre active
      if (this.hasAttribute('data-lecture')) {
        this.removeAttribute('data-lecture');
        void this.offsetWidth;
        this.toggleAttribute('data-lecture', true);
      }
      if (manuel) this.barres[i]?.focus();
    }
  }

  customElements.define('klapi-zoom', KlapiZoom);
}
